import {Component, ElementRef, Input} from '@angular/core';

@Component({
    selector: 'cb-td-text[value]',
    templateUrl: './text.component.html',
    styleUrls: ['./text.component.scss', './../table-cell.scss'],
    standalone: false
})
export class TdTextComponent {
    @Input() public readonly value: string | number;

    constructor(
        public readonly elementRef: ElementRef,
    ) {
    }
}
